import React, { useState } from 'react';
import Footer from '../../components/Footer';
import Navbar from '../../components/Navbar';
import Sidebar from '../../components/Sidebar';

import Page1 from '../../components/Goal/Page1';
import Page2 from '../../components/Goal/Page2';
import Page3 from '../../components/Goal/Page3';
import PageDay from '../../components/Day/Page1';
const Home: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    setIsOpen(!isOpen);
  };
  document.title = 'Xgreen - Our Goals';
  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <Page1 />
      <Page2 />
      <Page3 />
      <PageDay />
      <Footer />
    </>
  );
};

export default Home;
